import { conf } from '../config/config';
import { AUTH_TOKEN, SESSION_TOKEN, USER_UUID } from '../util/Constants';
import { getLocalStore } from '../util/Helpers';

export class ApiError extends Error {
    constructor(message, status, code) {
        super(message);
        this.name = 'ApiError';
        this.status = status;
        this.code = code;
    }
}

export async function request(path, options = {}) {
    const { body, headers = {}, auth = true, ...requestOptions } = options;
    const authToken = auth ? getLocalStore(AUTH_TOKEN) : null;
    const sessionToken = authToken ? getLocalStore(SESSION_TOKEN) : null;
    const userUuid = authToken ? getLocalStore(USER_UUID) : null;
    const response = await fetch(`${conf.endpoint.replace(/\/$/, '')}${path}`, {
        ...requestOptions,
        headers: {
            'Content-Type': 'application/json',
            ...(authToken ? { Authorization: `Bearer ${authToken}` } : {}),
            ...(sessionToken ? { 'X-Admin-Session-Token': sessionToken } : {}),
            ...(userUuid ? { 'X-Admin-User-UUID': userUuid } : {}),
            ...headers
        },
        ...(body === undefined ? {} : { body: JSON.stringify(body) })
    });
    const payload = await response.json().catch(() => ({}));

    if(!response.ok) {
        throw new ApiError(
            payload.error?.message || 'Unable to complete the request.',
            response.status,
            payload.error?.code
        );
    }

    return payload;
}
